import React, { useEffect } from 'react';
import Info from './Info';
import { css } from 'emotion';
import Hours from './Hours';
import Prices from './Prices';
import Impressum from './Impressum';
import { Switch, Route, useLocation } from 'react-router-dom';

function Content() {
  let location = useLocation();

  useEffect(() => navigate(location.pathname));

  return (
    <div className={style.container}>
      <Switch>
        <Route exact path="/impressum">
          <Impressum />
        </Route>
        <Route path="*">
          <Info />
          <Hours />
          <Prices />
        </Route>
      </Switch>
    </div>
  );
}

function navigate(path: string) {
  if (path === '/' || path === '/impressum') {
    window.scrollTo(0, 0);
    return;
  }
  const id = path?.substring(1);
  const position = document.getElementById(id)?.offsetTop;
  if (position) {
    window.scrollTo(0, Math.max(position - 50, 0));
  }
}

const style = {
  container: css`
    padding: 10px;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  `,
};

export default Content;
